import { render, staticRenderFns } from "./HealthScreen.vue?vue&type=template&id=9a39be32&"
import script from "./HealthScreen.vue?vue&type=script&lang=ts&"
export * from "./HealthScreen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports